// Browser API client (v2.3 §2). Same-origin /api/*, cookie auth (credentials:
// 'include'), CSRF header on every call. Holds NO Supabase keys — nothing.
const BASE = process.env.REACT_APP_API_URL || "/api";

async function request(method, path, body) {
  const res = await fetch(BASE + path, {
    method,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "fetch", // CSRF second layer (§4.1)
    },
    body: body == null ? undefined : JSON.stringify(body),
  });
  if (res.status === 401) { throw new Error("unauthenticated"); }
  if (!res.ok) {
    let detail = "";
    try { detail = (await res.json())?.error?.message || ""; } catch {}
    throw new Error(`${res.status} ${detail}`);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const apiGet = (path) => request("GET", path);
export const apiPost = (path, body) => request("POST", path, body);
export const apiDel = (path) => request("DELETE", path);

// Shared SSE connection (§8). One stream; subscribers filter by table.
let es = null;
const subs = new Set();
function ensureStream() {
  if (es || typeof window === "undefined") return;
  es = new EventSource(BASE + "/events", { withCredentials: true });
  es.onmessage = (e) => {
    let msg; try { msg = JSON.parse(e.data); } catch { return; }
    for (const s of subs) if (s.table === msg.table) s.cb(msg);
  };
  es.onerror = () => { /* EventSource auto-reconnects */ };
}

export function onTable(table, cb) {
  const s = { table, cb };
  subs.add(s);
  ensureStream();
  return () => {
    subs.delete(s);
    if (subs.size === 0 && es) { es.close(); es = null; }
  };
}
